import { render } from "./Visual.vue?vue&type=template&id=2b0485a4"
import script from "./Visual.vue?vue&type=script&lang=js"
export * from "./Visual.vue?vue&type=script&lang=js"

import "./Visual.vue?vue&type=style&index=0&id=2b0485a4&lang=css"

import exportComponent from "/home/pdu/dbesslnc/v1/v1/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__